<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table :headers="headers" :items="eventos" :search="search" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar color="white">
                        <v-toolbar-title>Eventos</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>

                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda"
                            single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>

                        <v-dialog v-model="dialog" max-width="500">
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12" class="py-0">
                                                <v-text-field v-model="eventonombre" label="Nombre del Evento"
                                                    outlined></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" class="py-0">
                                                <v-text-field v-model="eventodetalle" label="Detalle del Evento"
                                                    outlined></v-text-field>
                                            </v-col>

                                            <v-row>
                                                <v-col cols="6" sm="6" md="6" class="py-0">
                                                    <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fecha1"
                                                        persistent width="290px">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-model="fecha1" :readonly="fecha1 == 1"
                                                                label="Fecha de Inicio" prepend-icon="event"
                                                                v-bind="attrs" v-on="on" solo
                                                               ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="fecha1" scrollable locale="es-es"
                                                            :readonly="fecha1 == 1">
                                                            <v-spacer></v-spacer>
                                                            <v-btn text color="primary"
                                                                @click="modal1 = false">Cancelar</v-btn>
                                                            <v-btn text color="primary"
                                                                @click="$refs.dialog1.save(fecha1), listar()">OK</v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>

                                                <v-col cols="6" sm="6" md="6" class="py-0">
                                                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="fecha2"
                                                        persistent width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field v-model="fecha2" :readonly="fecha2 == 1"
                                                                label="Fecha Fin" prepend-icon="event" v-on="on"
                                                                solo></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="fecha2" scrollable locale="es-es"
                                                            :readonly="fecha2 == 1">
                                                            <v-spacer></v-spacer>
                                                            <v-btn text color="primary"
                                                                @click="modal = false">Cancelar</v-btn>
                                                            <v-btn text color="primary"
                                                                @click="$refs.dialog.save(fecha2)">OK</v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                            </v-row>


                                            <v-col cols="12" sm="12" md="12" class="py-0">
                                                <v-select v-model="eventoperiodoid" :items="eventoperiodo"
                                                    label="Tipo de Evento" outlined></v-select>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" class="py-0">
                                                <v-select v-model="expedienteid" :items="expedienteselect" label="Tarea"
                                                    outlined></v-select>
                                            </v-col>



                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                    </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-icon dense class="mr-2" @click="editItem(item)" v-on="on">edit</v-icon>
                        </template>
                        <span>Editar turno</span>
                    </v-tooltip>


                    <template v-if="item.turnoestatus == 1">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon dense class="mr-2" @click="desactivar(item)" v-on="on">toggle_off</v-icon>
                            </template>
                            <span>Desactivar </span>
                        </v-tooltip>
                    </template>

                    <template v-if="item.turnoestatus == 2">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon dense class="mr-2" @click="activar(item)" v-on="on">toggle_on</v-icon>
                            </template>
                            <span>Activar </span>
                        </v-tooltip>
                    </template>

                    <template>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon dense class="mr-2" @click="eliminar(item)" v-on="on">delete</v-icon>
                            </template>
                            <span>Eliminar </span>
                        </v-tooltip>
                    </template>


                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="listar">Reset</v-btn>
                </template>
                <template v-slot:item.turnoestatus="{ item }">
                    <v-chip :color="getColor(item.turnoestatus)" dark v-if="item.turnoestatus == 1">ABIERTO</v-chip>
                    <v-chip :color="getColor(item.turnoestatus)" dark v-if="item.turnoestatus == 2">CERRADO</v-chip>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            // Variables
            eventos: [],
            turnonumeros: [],
            turnonumeroid: "",
            turnoid: "",
            dialog: false,
            turnofecha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
            ),
            modal: false,
            modal1: false,
            menu: false,
            modal: false,
            headers: [
                { text: "Operacion", value: "action", sortable: false },
                { text: "Evento", value: "eventonombre" },
                { text: "Descripcion", value: "eventodetalle" },
                { text: "Fecha ini", value: "eventofechainicio" },
                { text: "Fecha fin", value: "eventofechafin" },
                { text: "Estatus", value: "eventoestatus", sortable: false },
            ],
            search: "",
            turnonombre: "",
            usuarioid: "",
            guardarsino: 0,
            eventonombre: "",
            eventodetalle: "",

            fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
            fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
            modal: false,
            modal1: false,
            menu: false,
            menu1: false,
            modal: false,
            eventoperiodoid: "",
            eventoperiodo: [
                { text: "DIARIO", value: 1 },
                { text: "SEMANAL", value: 2 },
                { text: "QUINCENAL", value: 3 },
                { text: "MENSUAL", value: 4 },
                { text: "BIMESTRAL", value: 5 },
                { text: "SEMESTRAL", value: 6 },
                { text: "LIBRE", value: 7 }
            ],

            expedienteid: "",
            expedienteselect: [],

        };
    },
    // Crea una nueva categoria si es -1
    computed: {
        formTitle() {
            if (this.guardarsino == 0) {
                return "Nuevo turno";
            } else {
                return "Modificar turno";
            }

        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.listar();
        this.listarexpediente();
    },

    //
    methods: {
        getHumanDate: function (date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },

        getColor(socioestatus) {
            if (socioestatus == 1) return "#3F8103"; // Verde
            if (socioestatus == 2) return "#DA0707"; // Rojo
        },
        // metodo listar
        listar() {
            // Variable para cargar los datos del api
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Manda llamar al listado e catalogos
            axios
                .get("api/eventos/listarevento", configuracion)
                .then(function (response) {
                    me.eventos = response.data.evento;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        // Actualiza la categotia
        editItem(item) {
            this.dialog = true;
            this.turnonumeroid = item.turnonumeroid;
            this.turnofecha = item.turnofecha;
            this.turnoid = item.turnonumeronumero;
            this.usuarioid = item.usuarioid;
            this.guardarsino = 1;
        },

        close() {
            this.reportes = false;
            this.dialog = false;
            this.limpiar();
        },

        limpiar() {
            this.turnonumeroid = "";
            this.turnoid = "";
            this.guardarsino = 0;
            this.eventoperiodoid="";
            this.eventonombre="";
            this.eventodetalle="";
            this.fecha1= moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD");
            this.fecha2= moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD");
            this.expedienteid= "";
        },

        guardar() {
           
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            let me = this;

            // Guardar
            if (me.guardarsino == 0) {
                axios
                    .post(
                        "api/eventos/crear",
                        {
                            eventonombre: me.eventonombre,
                            eventodetalle: me.eventodetalle,
                            eventofechainicio: me.fecha1,
                            eventofechafin: me.fecha2,
                            eventoperiodo: me.eventoperiodoid,
                            expedienteid: me.expedienteid
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.limpiar();
                        me.listar();
                        me.TablaVisible = 0;
                        me.dialog = false;
                        console.log(response.data)
                        me.$swal("Turno Capturado con Exito");
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.data.code == 400) {
                            me.$swal("La Sesión a Expirado");
                            me.$store.dispatch("salir");
                        }
                    });
            }
            // Editar
            if (me.guardarsino == 1) {
                axios
                    .put(
                        "api/turnos/actualizar/" + me.turnoid,
                        {
                            turnonumeroid: me.turnonumeroid,
                            turnofecha: me.turnofecha
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.TablaVisible = 0;
                        me.limpiar();
                        me.listar();
                        me.dialog = false;
                        me.$swal("turno Actualizado con Exito");
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.data.code == 400) {
                            me.$swal("La Sesión a Expirado");
                            me.$store.dispatch("salir");
                        }
                    });
            }


        },

        listarexpediente() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/expedientes/listar", configuracion)
                .then(function (response) {
                    listaArray = response.data.expediente;
                    listaArray.map(function (x) {
                        me.expedienteselect.push({
                            text: x.expedientenombre,
                            value: x.expedienteid,
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        selectturnonumero() {
            let me = this;
            var listaArray = [];
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/turnonumeros/listar", configuracion)
                .then(function (response) {
                    listaArray = response.data.turnonumero;
                    listaArray.map(function (x) {
                        me.turnonumeros.push({
                            text: x.turnonumeronombre,
                            value: x.turnonumeronumero,
                        });
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

        desactivar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Cerrar el turno",
                text:
                    "turno: " +
                    item.turnoid,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Cerrar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/turnos/desactivar",
                            {
                                turnoid: item.turnoid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Cerrado", "Se a Cerrado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },

        activar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Abrir el turno",
                text:
                    "turno: " +
                    item.turnonombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Abrir",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/turnos/activar",
                            {
                                turnoid: item.turnoid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Abierto", "Se a Abierto con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },

        eliminar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Eliminar el turno",
                text:
                    "turno: " +
                    item.turnonumeronombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Eliminar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/turnos/eliminar",
                            {
                                turnoid: item.turnoid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },






    },
};
</script>